<template>
  <v-layout justify-center>
    <loading :active.sync="busy"/>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent max-width="290px"
      @keydown.esc="close()">

      <v-card>
        <v-card-title>
          {{ $t('fork_mp.fork_masterpiece') }}
        </v-card-title>
        
        <v-card-text v-if="!fork_success">
          <v-flex xs12>
            <v-text-field
              v-model.trim.lazy="title"
              @input="is_duplicated=false"
              @blur="$v.title.$touch();checkTitle()"
              :error-messages="title_errors">
              <template v-slot:label>
                {{ $t('fork_mp.title') }}
              </template>
            </v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="description">
              <template v-slot:label>
                {{ $t('fork_mp.description') }}
              </template>
            </v-textarea>
          </v-flex>

          <v-flex xs12>
            <div>View mode</div>
            <v-radio-group class="small-radio"
              v-model="mode" row>
              <v-radio v-for="(value, key) in project_mode"
                :key="key"
                :value="parseInt(key)">
                <template v-slot:label>
                  {{ $t('fork_mp.'+value.code) }}
                </template>
              </v-radio>
            </v-radio-group>
          </v-flex>

          <div v-if="error">
            <span class="required">
              <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
              {{ $t('alert.try_again') }}
            </span>
          </div>
        </v-card-text>

        <v-card-text v-else>
          {{ $t('fork_mp.complete') }}
        </v-card-text>

        <v-card-actions v-if="!fork_success">
          <v-spacer></v-spacer>
          <v-btn small text @click="close()">
            {{ $t('fork_mp.close') }}
          </v-btn>
          <v-btn small depressed color="primary" :disabled="disabled"
            @click="forkPiece()">
            {{ $t('fork_mp.fork') }}
          </v-btn>
        </v-card-actions>

        <v-card-actions right v-else>
          <v-spacer></v-spacer>
          <v-btn small text @click="dialog_fork=false">
            {{ $t('fork_mp.close') }}
          </v-btn>
          <v-btn small depressed color="primary" @click="getProject()">
            {{ $t('fork_mp.go_project') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { project_mode } from '../../../custom/model'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      busy: false,
      project_mode: project_mode,

      fork_success: false,
      error: false,

      title: "",
      description: "",
      mode: 0,
      is_duplicated: false,
      fork_proj_id: null,

      disabled: false,
    }
  },

  validations: {
    title: {
      required,
      isUnique() {
        return this.$v.title.$dirty &&
          this.$v.title.required &&
          !this.is_duplicated
      }
    },
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      projects: 'project/projects',
      mp_id: 'welcome/mp_id',
    }),

    project_title_list() {
      return this.projects.map(proj => proj.title)
    },

    title_errors() {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.required && errors.push(this.$t('fork_mp.required'))
      !this.$v.title.isUnique && errors.push(this.$t('fork_mp.title_not_available'))
      return errors
    },

    // mp_id() {
    //   return parseInt(this.$route.params.id)
    // },
  },
  
  methods: {
    close() {
      this.reset()
      this.$emit('update:dialog', false)
    },

    reset() {
      this.title = ""
      this.description = ""
      this.mode = 0
      this.is_duplicated = false
      this.fork_proj_id = null
      this.fork_success = false
    },

    checkTitle() {
      if (this.project_title_list.includes(this.title)) {
          this.is_duplicated = true
        } else { this.is_duplicated = false }
    },

    async forkPiece() {
      await this.$v.$touch()
      if (this.disabled) return
      if (!this.$v.$anyError) {
        this.disabled = true
        try {
          await this.$store.dispatch('gallery/forkMasterpiece', {
            mp_id: this.mp_id,
            title: this.title,
            description: this.description,
            mode: this.mode
          })
        } catch(e) {
          this.error = true
        } finally {
          if (!this.error) {
            this.$analytics.logEvent('click', { name: 'piece_btn_fork' })
            await this.$store.dispatch('gallery/forkMPImage', {
              mp_id: this.mp_id,
              proj_id: this.$store.getters['gallery/fork_proj_id'],
            })
            this.fork_success = true
            this.fork_proj_id = this.$store.getters['gallery/fork_proj_id']
          }
          setTimeout(() => {
            this.disabled = false
          }, 500)
        }
      }
    },

    getProject() {
      this.$router.push({name: 'project', params: {id: this.fork_proj_id}})
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/modal/gallery/ForkMasterpiece.vue